import { ViewLayoutPlacement } from "@faire/web-api--source/indigofair/data/ViewLayoutPlacement";

import { useBrowseV3LayoutQuery } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/v3/useBrowseV3LayoutQuery";

export const useIsBrowseV3TopLayoutLoadedAndHasNoResults = () => {
  const {
    isError,
    isFetching,
    data: viewLayout,
  } = useBrowseV3LayoutQuery(ViewLayoutPlacement.TOP);

  if (isFetching || viewLayout === undefined) {
    return false;
  }
  if (isError) {
    return true;
  }

  return viewLayout?.content.length === 0;
};
